<div *ngIf="groupBookingForm" [formGroup]="groupBookingForm">
    <p-toast></p-toast>
    <p-dialog [(visible)]="isMappingHeader" [modal]="true">
        <form [formGroup]="csvHeadersForm">
            <table>
                <tr>
                    <td>
                        last_name*
                    </td>
                    <td>
                        <p-dropdown formControlName="lastName" [options]="csvHeaders" appendTo="body"></p-dropdown>
                    </td>
                </tr>
                <tr>
                    <td>
                        first_name*
                    </td>
                    <td>
                        <p-dropdown formControlName="firstName" [options]="csvHeaders" appendTo="body"></p-dropdown>
                    </td>
                </tr>
                <tr>
                    <td>
                        gender
                    </td>
                    <td>
                        <p-dropdown formControlName="gender" [options]="csvHeaders" appendTo="body"></p-dropdown>
                    </td>
                </tr>
                <tr>
                    <td>
                        start date*
                    </td>
                    <td>
                        <p-dropdown formControlName="startDate" [options]="csvHeaders" appendTo="body"></p-dropdown>
                    </td>
                </tr>
                <tr>
                    <td>
                        end date*
                    </td>
                    <td>
                        <p-dropdown formControlName="endDate" [options]="csvHeaders" appendTo="body"></p-dropdown>
                    </td>
                </tr>
                <tr>
                    <td>
                        birthdate*
                    </td>
                    <td>
                        <p-dropdown formControlName="birthDate" [options]="csvHeaders" appendTo="body"></p-dropdown>
                    </td>
                </tr>
                <tr>
                    <td>
                        allergies
                    </td>
                    <td>
                        <p-dropdown formControlName="allergies" [options]="csvHeaders" appendTo="body"></p-dropdown>
                    </td>
                </tr>
                <tr>
                    <td>
                        insurance
                    </td>
                    <td>
                        <p-dropdown formControlName="insurance" [options]="csvHeaders" appendTo="body"></p-dropdown>
                    </td>
                </tr>
            </table>
        </form>
        <p-button label="Confirm" (onClick)="addBookingsByCsv()"></p-button>

    </p-dialog>
    <div class="global-form">
        <div class="global-form-left-container">
            <h3 class="global-title">
                Create a Group Booking
            </h3>
            <button (click)="completeForm()">Set Mock value</button>
            <p-fileUpload #fileUploader accept="text/csv" mode="basic" [auto]="false"
                (onSelect)="onFileSelect($event.currentFiles)" [maxFileSize]="16000000" chooseIcon="pi pi-none"
                chooseLabel="Import a CSV file">
            </p-fileUpload>
            <div class="manual-container">
                <p>
                    *Csv Format: comma separated ',', column1: last name, column2: first name, column3: M/F, column4:
                    start
                    date, column5: end date (dd/MM/yyyy), column6: birth date (dd/MM/yyyy), column7: allergies, column8:
                    insurance type ("None", "AVI", "Langues vivantes")
                </p>
            </div>
            <div formGroupName="global" class="booking-global-form">
                <div class="booking-global-form-item">
                    <span>Group Name</span>
                    <input pInputText formControlName="groupName">
                </div>
                <div class="booking-global-form-item">
                    <span>Agent</span>
                    <p-dropdown [options]="agents" formControlName="salesAgent" optionLabel="name"></p-dropdown>
                </div>
                <div class="booking-global-form-item">
                    <span>Language of communication</span>
                    <p-dropdown placeholder="--Select--" [options]="languages" formControlName="language"
                        optionLabel="name"></p-dropdown>
                </div>
                <div class="booking-global-form-item">
                    <span>School</span>
                    <p-dropdown [filter]="true" filterBy="name" placeholder="--Select--" [options]="schools" optionLabel="name"
                        formControlName="school" (onChange)="onSchoolChange()"></p-dropdown>
                </div>
                <div class="booking-global-form-item">
                    <span>Destination</span>
                    <p-dropdown [filter]="true" filterBy="name" placeholder="--Select--" [options]="countries" optionLabel="name"
                        formControlName="destination">
                    </p-dropdown>
                </div>
                <div class="booking-global-form-item">
                    <span>Accommodation</span>
                    <p-dropdown [options]="accommodationTypes" formControlName="accommodationType"
                        optionLabel="name"></p-dropdown>
                </div>
                <div class="booking-global-form-item">
                    <span>
                        Start date
                    </span>
                    <p-calendar formControlName="startDate" dateFormat="dd/mm/yy"></p-calendar>
                </div>
                <div class="booking-global-form-item">
                    <span>Room</span>
                    <p-dropdown [options]="roomTypes" formControlName="roomType" optionLabel="name"></p-dropdown>
                </div>
                <div class="booking-global-form-item">
                    <span>
                        End date
                    </span>
                    <p-calendar formControlName="endDate" dateFormat="dd/mm/yy"></p-calendar>
                </div>
                <div class="booking-global-form-item">
                    <span>Meals</span>
                    <p-dropdown [options]="boardTypes" formControlName="boardType" optionLabel="name"></p-dropdown>
                </div>
                <div class="booking-global-form-item">
                    <span>Total amount they need to pay (EUR)</span>
                    <input pInputText formControlName="totalAmount" [style]="{'width': '90px'}">
                </div>
                <div class="booking-global-form-item">
                    <div>
                        <span class="with-margin-right">Manually encode due amount to each booking</span>
                        <p-checkbox [binary]="true" formControlName="manualAmountEncoding"></p-checkbox>
                    </div>
                </div>
                <div class="booking-global-form-item">
                    <span>Deposit (EUR)</span>
                    <input pInputText formControlName="deposit" [style]="{'width': '90px'}">
                </div>
                <div class="booking-global-form-item">
                    <span>Due date</span>
                    <p-calendar formControlName="dueDate" dateFormat="dd/mm/yy" appendTo="body"
                        [inputStyle]="{'width':'100%'}"></p-calendar>
                </div>
                <div class="booking-global-form-item">
                    <span>Travel Insurance</span>
                    <p-dropdown placeholder="None" [options]="insuranceSuppliers" optionLabel="name"
                        formControlName="insurance"></p-dropdown>
                </div>
                <div class="booking-global-form-item">
                    <span>Students</span>
                    <div>
                        <input class="with-margin-right" placeholder="0-99" pInputText type="text"
                            formControlName="formAddNumber" [style]="{'width': '50px'}">
                        <p-button label="Add" (onClick)="addBookingForms()"
                            [disabled]="bookingGlobalForm.invalid"></p-button>
                    </div>
                </div>
                <div>
                    <p-button label="Submit" (onClick)="postGroupBooking()"
                        [disabled]="groupBookingForm.invalid || bookingFormArray.length == 0"></p-button>
                </div>
            </div>
        </div>

        <div class="global-form-right-container">
            <p-button label="Add accompanist/guide" (onClick)="insertGuideForm()"></p-button>
            <div *ngIf="guideFormArray.controls.length >0" class="guide-form-header">
                <div>First name</div>
                <div>
                    Last name
                </div>
                <div>
                    Phone
                </div>
                <div>
                    Email
                </div>
                <div>
                    Accommodation
                </div>
                <div>

                </div>
            </div>
            <div *ngFor="let form of guideFormArray.controls; let i = index" formArrayName="guides">
                <div [formGroupName]="i" class="guide-form-container">
                    <input pInputText formControlName="firstName">
                    <input pInputText formControlName="lastName">
                    <input pInputText formControlName="phoneNumber">
                    <input pInputText formControlName="email">
                    <input pInputText formControlName="address">
                    <p-button icon="pi pi-trash" (onClick)="removeGuideFormItem(i)"
                        styleClass="p-button-danger"></p-button>
                </div>
            </div>
        </div>
    </div>
    <p-table [value]="bookingFormArray.controls">
        <ng-template pTemplate="header">
            <tr>
                <th>
                    *Last Name
                </th>
                <th>
                    *First Name
                </th>
                <th [style]="{'width': '180px'}">
                    M/F
                </th>
                <th [style]="{'width': '130px'}">
                    *Start
                </th>
                <th [style]="{'width': '130px'}">
                    *End
                </th>
                <th [style]="{'width': '120px'}">
                    *Course
                </th>
                <th [style]="{'width': '130px'}">
                    *Birth Date
                </th>
                <th>
                    Allergies
                </th>
                <th [style]="{'width': '120px'}">
                    Room
                </th>
                <th>
                    Accom.
                </th>
                <th [style]="{'width': '168px'}">
                    Insurance
                </th>
                <th [style]="{'width': '120px'}">
                    *Amt.
                </th>
                <th [style]="{'width':'80px'}">

                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-form let-rowIndex="rowIndex">
            <ng-container formArrayName="bookings">
                <tr [formGroupName]="rowIndex">
                    <td>
                        <input pInputText formControlName="lastName" class="large-input">
                    </td>
                    <td>
                        <input pInputText formControlName="firstName" class="large-input">
                    </td>
                    <td>
                        <div class="genders-container">
                            <p-selectButton [options]="genders" optionLabel="symbol"
                                formControlName="gender"></p-selectButton>
                        </div>
                    </td>
                    <td>
                        <p-calendar formControlName="startDate" dateFormat="dd/mm/yy" appendTo="body"
                            [inputStyle]="{'width':'100%'}"></p-calendar>
                    </td>
                    <td>
                        <p-calendar formControlName="endDate" dateFormat="dd/mm/yy" appendTo="body"
                            [inputStyle]="{'width':'100%'}"></p-calendar>
                    </td>
                    <td>
                        <p-dropdown appendTo="body" placeholder="-Select-" optionLabel="code"
                            [options]="languageCourseList" formControlName="languageCourse"
                            [style]="{'minWidth': '100%'}"></p-dropdown>
                    </td>
                    <td>
                        <p-calendar [yearNavigator]="true" [yearRange]="birthYearRange" [defaultDate]="defaultBirthDate"
                            formControlName="birthDate" dateFormat="dd/mm/yy" appendTo="body"
                            [inputStyle]="{'width':'100%'}"></p-calendar>
                    </td>
                    <td>
                        <input pInputText formControlName="allergies" class="large-input">
                    </td>
                    <td>
                        <p-dropdown appendTo="body" placeholder="---" [options]="roomNames" optionLabel="name"
                            formControlName="studentRoom" [style]="{'minWidth': '100%'}"></p-dropdown>
                    </td>
                    <td>
                        {{form.value.accommodationType.name}}, {{form.value.roomType.name}} room,
                        {{form.value.boardType.name}}
                    </td>
                    <td>
                        <p-dropdown appendTo="body" placeholder="None" [options]="insuranceSuppliers" optionLabel="name"
                            formControlName="insuranceSupplier" [style]="{'minWidth': '100%'}"></p-dropdown>
                    </td>
                    <td>
                        <input pInputText formControlName="dueAmount" [style]="{'width': '90px'}">
                    </td>
                    <td>
                        <p-button icon="pi pi-trash" (onClick)="removeBookingFormItem(rowIndex)"
                            styleClass="p-button-danger"></p-button>
                    </td>
                </tr>
            </ng-container>
        </ng-template>
    </p-table>
</div>